import { createStyles, Grid, makeStyles, Theme, Typography } from '@agentnet/components';
import { ArrowBack, ArrowDropDownCircleOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';
import { Article } from '../../types';
import { RenderContent } from '../RenderContent/RenderContent';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import { ArticleTip } from './ArticleTip';
import { RelatedArticles } from './RelatedArticles';

type ArticleBodyProps = {
  article: Article | undefined;
  isPdf: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    articleBody: {
      marginTop: theme.spacing(1),
      '& ol': {
        '& ul': {
          listStyle: 'disc',
          '& ul': {
            listStyle: 'circle',
            '& ul': {
              listStyle: 'square',
            },
          },
        },
        '& ol': {
          listStyle: 'upper-alpha',
          '& ol': {
            listStyle: 'lower-roman',
            '& ol': {
              listStyle: 'lower-alpha',
              '& ol': {
                listStyle: 'decimal',
              },
            },
          },
        },
      },
    },
    cta: {
      marginBottom: theme.spacing(2),
      flexGrow: 1,
      justifyContent: 'flex-start',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        flexGrow: 0,
        width: 'auto',
      },
    },
  }),
);
function ArticleBody({ article, isPdf }: ArticleBodyProps) {
  const classes = useStyles();
  const history = useHistory();

  const downloadArticleAsset = async () => {
    const link = document.createElement('a');
    link.href = article?.relatedAsset?.url ?? '';
    link.download = article?.relatedAsset?.fileName ?? 'article.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Grid container>
      {article && (
        <>
          {!isPdf && (
            <AgentNetButton
              className={classes.cta}
              variant="text"
              size="medium"
              color="primary"
              startIcon={<ArrowBack htmlColor="primary" />}
              onClick={() => history.goBack()}
            >
              Back
            </AgentNetButton>
          )}
          <Grid item sm={12}>
            <Typography variant="h1">{article?.articleTitle}</Typography>
          </Grid>
          {article.enableDownload && article.relatedAsset?.url && (
            <AgentNetButton
              className={classes.cta}
              variant="text"
              size="medium"
              color="primary"
              startIcon={<ArrowDropDownCircleOutlined htmlColor="primary" />}
              onClick={() => downloadArticleAsset()}
            >
              Download
            </AgentNetButton>
          )}
          <Grid item sm={12}>
            {article.wistiaVideo?.items?.[0] && <VideoPlayer wistiaData={article.wistiaVideo} />}
            <div className={classes.articleBody}>
              <RenderContent document={article?.articleBody} />
            </div>
          </Grid>
          <ArticleTip articleTip={article?.articleTip} />
          <RelatedArticles relatedArticles={article?.relatedArticlesCollection?.items} />
        </>
      )}
    </Grid>
  );
}

export { ArticleBody };
